import { ventasConstants } from '../_constants';

export function ventas(state = {}, action) {
  switch (action.type) {
    default:
      return state
  }
}